import { Component, OnInit } from '@angular/core';
import dayjs from 'dayjs';
import { Date_range } from 'src/app/core/models/date-range';
import { BillingService } from 'src/app/services/billing/billing.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
// import { ColumnMode } from '@swimlane/ngx-datatable';

@Component({
	selector: 'app-billing-report',
	templateUrl: './billing-report.component.html',
	styleUrls: ['./billing-report.component.scss'],
})
export class BillingReportComponent implements OnInit {
	report: any;
	weeklyInvoices: any[] = [];
	weekLabel: string = '';

	activeTab: string = 'charge';
	campaignTab: string = 'active';
	campaignList: any[] = [];
	campaignFilters = { client: 'All' };
	clientList: any[] = [];
	user: any;

	// ColumnMode = ColumnMode;
	rowPerPage = 10;

	dateRange_: Date_range = {
		dateStart: dayjs().startOf('year'),
		dateEnd: dayjs().endOf('year'),
	};

	Math = Math;

	page = 1;
	pageSize = 10;

	dateRangeInvoices_: Date_range = {
		dateStart: dayjs().startOf('week'),
		dateEnd: dayjs().endOf('week'),
	};

	constructor(
		private billingSrv: BillingService,
		private utilsSrv: UtilsService,
	) {}

	ngOnInit() {
		this.weekLabel = this.utilsSrv.getWeekLabel();
		this.loadBillingReport();
		this.SearchData();
	}

	getDateRange(): string {
		const now = new Date();

		const startMonth = new Intl.DateTimeFormat('en-US', {
			month: 'short',
		}).format(new Date(now.getFullYear(), 0));

		const currentMonth = new Intl.DateTimeFormat('en-US', {
			month: 'short',
		}).format(now);

		const year = now.getFullYear();

		return `${startMonth}–${currentMonth} ${year}`;
	}

	dateSelectedInvoices(range: Date_range) {
		this.dateRangeInvoices_ = range;
		this.loadBillingReport(range.dateStart.format('YYYY-MM-DD'), range.dateEnd.format('YYYY-MM-DD'));
	}

	// getWeekRange(): string {
	// 	const today = new Date();
	// 	const day = today.getDay();
	// 	const diffToMonday = day === 0 ? -6 : 1 - day;

	// 	const monday = new Date(today);
	// 	monday.setDate(today.getDate() + diffToMonday);

	// 	const formatter = new Intl.DateTimeFormat('en-US', {
	// 		month: 'short',
	// 		day: 'numeric',
	// 	});

	// 	return formatter.format(monday);
	// }

	loadBillingReport(from: string | null = null, to: string | null = null): void {
		this.billingSrv.getBillingReport(from, to).subscribe({
			next: (data: any) => {
				this.report = data.body;
				this.weeklyInvoices = data.body.weekly_invoices;
				this.page = 1;
			},
			error: (err) => {
				console.error('Error al cargar billing report', err);
			},
		});
	}
	formatCurrency(value: number): string {
		if (value === null || value === undefined) return '';
		if (value >= 1000) {
			const thousands = value / 1000;
			return `$${thousands.toFixed(1).replace('.', ',')}k`;
		}
		return `$${value}`;
	}

	toggleCampaignList(status: 'active' | 'inactive') {
		this.campaignTab = status;
	}

	get filteredCampaigns(): any[] {
		return this.campaignList.filter((c) => (this.campaignTab === 'active' ? c.isActive === 1 : c.isActive === 0));
	}

	filterCampaigns() {
		// filtra campaignList según campaignFilters
	}

	SearchData() {
		const payload = {
			date_start: dayjs(this.dateRange_.dateStart).format('YYYY-MM-DD'),
			date_end: dayjs(this.dateRange_.dateEnd).format('YYYY-MM-DD'),
		};

		this.billingSrv.getCampaignRevenue(payload).subscribe((res: any) => {
			if (res?.success) {
				this.campaignList = res?.body ?? [];
			} else {
				this.campaignList = [];
			}
		});
	}

	dateSelected(range: Date_range) {
		this.dateRange_ = range;
		this.SearchData();
	}

	setActiveTab(tab: string) {
		this.activeTab = tab;
		if (tab === 'revenue') {
			this.SearchData();
		}
	}

	getTotal(prop: string): number {
		return this.campaignList.reduce((acc, row) => acc + (Number(row[prop]) || 0), 0);
	}

	getGlobalAvgPerLead(): string {
		const totalRevenue = this.getTotal('Revenue');
		const totalBilled = this.getTotal('billead_leads');
		return totalBilled > 0 ? (totalRevenue / totalBilled).toFixed(2) : '-';
	}

	getGlobalPctRevenue(): string {
		const totalRevenue = this.getTotal('Revenue');
		const grandTotal = this.campaignList.reduce((acc, row) => acc + (Number(row.Revenue) || 0), 0);
		return grandTotal > 0 ? ((totalRevenue / grandTotal) * 100).toFixed(1) : '-';
	}

	get activeCount(): number {
		return this.campaignList.filter((c) => c.isActive === 1).length;
	}

	get inactiveCount(): number {
		return this.campaignList.filter((c) => c.isActive === 0).length;
	}

	get totalPages(): number {
		return Math.ceil(this.weeklyInvoices.length / this.pageSize);
	}

	get totalPagesArray(): number[] {
		return Array.from({ length: this.totalPages }, (_, i) => i + 1);
	}

	goToPage(page: number): void {
		if (page < 1 || page > this.totalPages) return;
		this.page = page;
	}
}
